import React, { useState, createElement } from 'react';
import { DownloadIcon, RefreshCwIcon, Trash2Icon, ChevronRightIcon, AlertTriangleIcon } from 'lucide-react';
import { alertsData } from '../data/alertsData';
import { AlertDetailModal } from './AlertDetailModal';
import type { Alert } from '../data/alertsData';
export function AlertsPanel() {
  const [selectedAlert, setSelectedAlert] = useState<Alert | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleAlertClick = (alert: Alert) => {
    setSelectedAlert(alert);
    setIsModalOpen(true);
  };
  const handleDownloadAlert = (alert: Alert, e: React.MouseEvent) => {
    e.stopPropagation();
    const headers = ['Reference', 'Design', 'Desired Stock', 'Current Stock', 'Incoming', 'Shortage', 'Priority'];
    const rows = alert.references.map(item => [item.reference, item.design, item.desiredStock.toString(), item.currentStock.toString(), item.incoming.toString(), Math.abs(item.difference).toString(), item.priority.toUpperCase()]);
    const csvContent = [headers.join(','), ...rows.map(row => row.join(','))].join('\n');
    const blob = new Blob([csvContent], {
      type: 'text/csv'
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `alert-${alert.id}-${new Date().toISOString().split('T')[0]}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
  };
  const handleRefreshAlert = (e: React.MouseEvent) => {
    e.stopPropagation();
    alert('Refreshing alert data...');
  };
  const handleDeleteAlert = (alertId: string, e: React.MouseEvent) => {
    e.stopPropagation();
    if (confirm('Are you sure you want to delete this alert?')) {
      alert(`Alert ${alertId} would be deleted`);
    }
  };
  const getSeverityColor = (severity: string) => {
    switch (severity) {
      case 'critical':
        return 'bg-red-50 hover:bg-red-100 border-red-200';
      case 'high':
        return 'bg-orange-50 hover:bg-orange-100 border-orange-200';
      case 'medium':
        return 'bg-yellow-50 hover:bg-yellow-100 border-yellow-200';
      default:
        return 'bg-gray-50 hover:bg-gray-100 border-gray-200';
    }
  };
  return <div className="space-y-4" data-id="element-69">
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-70">
        <div className="flex items-center justify-between mb-6" data-id="element-71">
          <div className="flex items-center gap-3" data-id="element-72">
            <div className="w-10 h-10 bg-gradient-to-br from-red-500 to-red-600 rounded-lg flex items-center justify-center shadow-lg shadow-red-500/30" data-id="element-73">
              <AlertTriangleIcon className="w-5 h-5 text-white" data-id="element-74" />
            </div>
            <div data-id="element-75">
              <h2 className="text-xl font-bold text-gray-900" data-id="element-76">Stock Alerts</h2>
              <p className="text-sm text-gray-600" data-id="element-77">
                {alertsData.length} active alerts
              </p>
            </div>
          </div>
        </div>
        <div className="space-y-3" data-id="element-78">
          {alertsData.map(alert => <div key={alert.id} onClick={() => handleAlertClick(alert)} className={`flex items-center justify-between p-4 rounded-lg border transition-all cursor-pointer group ${getSeverityColor(alert.severity)}`} data-id="element-79">
              <div className="flex-1" data-id="element-80">
                <div className="flex items-center gap-3 mb-1" data-id="element-81">
                  <AlertTriangleIcon className={`w-5 h-5 ${alert.severity === 'critical' ? 'text-red-600' : alert.severity === 'high' ? 'text-orange-600' : 'text-yellow-600'}`} data-id="element-82" />
                  <h3 className="font-semibold text-gray-900" data-id="element-83">{alert.title}</h3>
                  <span className={`px-2 py-0.5 rounded text-xs font-semibold ${alert.severity === 'critical' ? 'bg-red-100 text-red-700' : alert.severity === 'high' ? 'bg-orange-100 text-orange-700' : 'bg-yellow-100 text-yellow-700'}`} data-id="element-84">
                    {alert.count} items
                  </span>
                </div>
                <p className="text-sm text-gray-600" data-id="element-85">
                  Last update: {alert.lastUpdate}
                </p>
              </div>
              <div className="flex items-center gap-2" data-id="element-86">
                <button onClick={e => handleDownloadAlert(alert, e)} className="p-2 text-gray-600 hover:bg-white rounded transition-colors" title="Download Excel" data-id="element-87">
                  <DownloadIcon className="w-5 h-5" data-id="element-88" />
                </button>
                <button onClick={handleRefreshAlert} className="p-2 text-gray-600 hover:bg-white rounded transition-colors" title="Refresh" data-id="element-89">
                  <RefreshCwIcon className="w-5 h-5" data-id="element-90" />
                </button>
                <button onClick={e => handleDeleteAlert(alert.id, e)} className={`p-2 rounded transition-colors ${alert.severity === 'critical' ? 'text-red-600 hover:bg-red-200' : 'text-gray-600 hover:bg-white'}`} title="Delete Alert" data-id="element-91">
                  <Trash2Icon className="w-5 h-5" data-id="element-92" />
                </button>
                <ChevronRightIcon className={`w-5 h-5 text-gray-400 group-hover:translate-x-1 transition-all ${alert.severity === 'critical' ? 'group-hover:text-red-600' : alert.severity === 'high' ? 'group-hover:text-orange-600' : 'group-hover:text-yellow-600'}`} data-id="element-93" />
              </div>
            </div>)}
        </div>
      </div>
      <AlertDetailModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} alert={selectedAlert} data-id="element-94" />
    </div>;
}